module.exports = __webpack_public_path__ + "img/difficulty.90eab7ad.png";